import Phaser, { Math } from "phaser";
import { GameEvents, BOARD_SIZE } from "../../constants";

export class DoorPowerParticles {
  private emitter1: Phaser.GameObjects.Particles.ParticleEmitter;
  private scene: Phaser.Scene;
  constructor(scene: Phaser.Scene) {
    this.scene = scene;
    const particleManager = scene.add.particles("atlas");
    particleManager.setDepth(1000);
    this.emitter1 = particleManager.createEmitter({
      frame: ["FX/particle_shapes/particle_shapes3"],
      x: 0,
      y: 0,
      speed: { min: -10, max: 10 },
      angle: { min: 0, max: 360 },
      scale: { start: 1, end: 0 },
      alpha: { start: 0.7, end: 0 },
      blendMode: "SCREEN",
      active: true,
      frequency: -1,
      lifespan: 1000,
      gravityY: 0,
    });

    scene.events.on(GameEvents.FX_DoorToggled, this.toggledDoor, this);
    scene.events.once("destroyed", () => {
      scene.events.removeListener(
        GameEvents.FX_DoorToggled,
        this.toggledDoor,
        this
      );
    });
  }

  toggledDoor({
    isOpenSignal,
    fromX,
    fromY,
    toX,
    toY,
  }: {
    isOpenSignal: boolean;
    fromX: number;
    fromY: number;
    toX: number;
    toY: number;
  }) {
    if (isOpenSignal) {
      const closureObj = { x: fromX, y: fromY };

      this.scene.add.tween({
        targets: closureObj,
        x: { from: fromX, to: toX },
        y: { from: fromY, to: toY },
        duration: 300,
        onUpdate: () => {
          if (Phaser.Math.FloatBetween(0, 1) < 0.2) {
            this.emitter1.explode(
              Phaser.Math.Between(1, 2),
              closureObj.x * BOARD_SIZE + 4,
              closureObj.y * BOARD_SIZE + 4
            );
          }
        },
      });
      console.log("toggled door");
    }
  }
}
